module.exports = __webpack_public_path__ + "static/forecast/temperature/very-cold-e46d041294d2148b90d8543b0036433a.svg";